import { Info } from 'lucide-react';
import { cn } from '@/shared/cn';

const TOOLTIP_COPY =
  'Platform skill — managed by your workspace (read-only). Contact your administrator for feedback or changes.';

const ICON_CLASS =
  'inline-flex h-3.5 w-3.5 flex-shrink-0 items-center justify-center text-muted';

type PlatformSkillInfoProps = {
  adminContactEmail?: string | null;
  skillSlug: string;
};

export function PlatformSkillInfo({
  adminContactEmail = null,
  skillSlug,
}: PlatformSkillInfoProps) {
  const subject = encodeURIComponent(`Feedback on platform skill: ${skillSlug}`);
  const body = encodeURIComponent(
    `Hi,\n\nI have feedback on the platform skill "${skillSlug}":\n\n`,
  );

  if (adminContactEmail) {
    return (
      <a
        href={`mailto:${adminContactEmail}?subject=${subject}&body=${body}`}
        className={cn(
          ICON_CLASS,
          'pointer-events-auto tt-below tt-wrap rounded-sm hover:text-zinc-700 dark:hover:text-zinc-200',
        )}
        aria-label="Send feedback on this platform skill"
      >
        <Info className="h-3.5 w-3.5" aria-hidden />
      </a>
    );
  }

  return (
    <button
      type="button"
      className={cn(
        ICON_CLASS,
        'pointer-events-auto tt-below tt-wrap rounded-sm',
      )}
      aria-label={TOOLTIP_COPY}
    >
      <Info className="h-3.5 w-3.5" aria-hidden />
    </button>
  );
}
